export default "__VITE_ASSET__DlCD4itP__"